import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import modalData from '../../data/modals.json';
import { Modal } from 'src/app/models';
import { CommonService, GoogleService, ModalService, StateService } from 'src/app/services';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-modal',
    templateUrl: './modal.component.html',
    styleUrls: ['./modal.component.scss']
})
export class ModalComponent implements OnInit {
    public transitionOut: boolean = false;
    public modalVisible: boolean = false;
    public modalData: Modal = undefined;
    public transitionTime: number = 350;
    public animating: boolean = false;
    public hideInner: boolean = false;
    public parent: string = '';

    public path: string = environment.assetBasePath;
    public pdfSrc: string = '';
    public iframeSource: any = '';

    constructor(
        private modalSvc: ModalService,
        public sanitizer: DomSanitizer,
        private commonSvc: CommonService,
        private googleSvc: GoogleService,
        private stateSvc: StateService
    ) { }

    ngOnInit(): void {
        this.subscribe();
    }

    public subscribe(): void {
        this.modalSvc.visible.subscribe(visible => {
            if (visible) {
                this.transitionOut = false;
                this.modalVisible = true;
            } else {
                this.transitionOut = true;
                setTimeout(() => {
                    this.modalVisible = false;
                }, this.transitionTime);
            }
        });

        this.modalSvc.modalData.subscribe(data => {

            console.log('data', data);
            let pause = false;
            this.hideInner = true;
            setTimeout(() => { this.hideInner = false }, 550);

            // We're in a modal and a link is opening a new modal
            if (this.modalData !== undefined) {
                pause = true;
                this.setAnimating();
                this.parent = (this.parent === '') ? this.modalData.id : '';
            } else {
                this.parent = '';
                this.pdfSrc = '';
            }

            setTimeout(() => {
                this.modalData = data;
                this.handleModalSpecifics(this.modalData?.modal_type);
            }, (data && !pause ? 0 : this.transitionTime));
        });
    }

    public handleModalSpecifics(type: string): void {
        switch (type) {
            case 'iframe':
                this.iframeSource = this.sanitizer.bypassSecurityTrustResourceUrl(this.modalData.iframe);
                this.googleSvc.sendGAEventById(11, { category: this.modalData.id, label: this.modalData.iframe });
            break;

            case 'pdf':
                this.pdfSrc = this.modalData.pdf;
                console.log(this.modalData.pdf);
                if (!this.pdfSrc.includes('http')) {
                    this.pdfSrc = this.path + this.pdfSrc;
                    this.googleSvc.sendGAEventById(10, { category: this.modalData.id, label: this.modalData.pdf });
                }
            break;
        }
    }

    public setAnimating(): void {
        this.animating = true;
        setTimeout(() => { this.modalData = undefined }, 350);
        setTimeout(() => { this.animating = false }, 550);
    }

    public closeModal(): void {
        if (this.parent === '') {
            this.modalSvc.hideModal();
        } else {
            const data: Modal = modalData.find(el => el.id === this.parent);
            data.isi_expanded = false;
            this.modalSvc.setActiveModalByData(data);
        }
    }
}
